import { render } from "./MobileMenu.vue?vue&type=template&id=a52937be&scoped=true&ts=true"
import script from "./MobileMenu.vue?vue&type=script&lang=ts"
export * from "./MobileMenu.vue?vue&type=script&lang=ts"

import "./MobileMenu.vue?vue&type=style&index=0&id=a52937be&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a52937be"]])

export default __exports__